import React, { useCallback, useEffect, useState } from "react";
import { Card, Skeleton, Space } from "antd";
import { Link } from "react-router-dom";

import { getEmployeesHome } from "../../store/api/employees";
import { config } from "../../config";

const Employees = () => {
  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);

  const fetchData = useCallback(() => {
    setLoading(true);
    getEmployeesHome({ showOnHomePage: true })
      .then(({ data }) => {
        setEmployees(data.employees);
      })
      .catch(() => {
        //
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <section className="home-employees">
      <h3 style={{ fontWeight: "bold" }}>Employees</h3>
      <p style={{ color: "#777777" }}>
        List of employees to show on about section in the home page. Select upto
        3 for best results. Go to <Link to={"/employees"}>Employees</Link> page
        to make changes.
      </p>
      {loading ? (
        <Space>
          <Skeleton.Image active={loading} />
          <Skeleton.Image active={loading} />
        </Space>
      ) : (
        <Space align="start">
          {employees.map((employee) => (
            <Card
              style={{ width: 180 }}
              cover={
                <img
                  alt={`${employee.name}`}
                  src={`${config.filesBaseUrl}/${employee.filePath}`}
                  style={{
                    width: "180px",
                    height: "180px",
                    objectFit: "cover",
                  }}
                />
              }
            >
              <Card.Meta
                title={`${employee.name}`}
                description={`${employee.position}`}
                style={{ margin: "-12px" }}
              />
            </Card>
          ))}
        </Space>
      )}
      {}
    </section>
  );
};

export default Employees;
